import { MutationTree } from 'vuex'
import { Cart } from '~/composables/propeller/getters'

// Shared cart state for the propeller composables. Lives in Vuex
// so it is per-request on the server, hydrated to the client, and reactive
// across every component that calls useCart().
export interface CartState {
  cart: Cart | Record<string, never> | null
}

export function state (): CartState {
  return ({
    cart: null
  })
}

export const mutations: MutationTree<CartState> = {
  SET_CART (state, data: CartState['cart']) {
    state.cart = data
  }
}
